import React from 'react';
import ContactsTab from './surveillance/ContactsTab';
import PageHeader from './shared/PageHeader';
import ContactGroups from './surveillance/ContactGroups';

/**
 * Kontakter: egen sida. Kontakterna används av larmregler, egenkontrollens scheman
 * (ansvarig och andra kontakt) och mallarnas "meddela vid klart".
 * Listan och formuläret sköts av ContactsTab (useContactForm).
 */
const Contacts: React.FC = () => (
    <div>
        <PageHeader icon="👤" title="Kontakter"
            description="Kontakterna används för larm under Bevakning och för egenkontrollens scheman och mallar. Sms och larmtider gäller bara larmen. Egenkontrollen skickar alltid med e-post, därför måste alla kontakter ha en e-postadress." />
        <ContactsTab />
        <ContactGroups />
    </div>
);

export default Contacts;
